import { TRootState } from "../store/create-store";
import { selectLeftPanelState } from "../selectors";
import { generatePCACacheKey } from "../utils/utils";
import { selectPCAForCacheKey } from "./worker.selector";

export const selectPCAForSelectedMethod = (state: TRootState) => {
  const { selectedDataset, selectedMethod } = selectLeftPanelState(state);
  if (!selectedDataset || !selectedMethod) {
    return undefined;
  }

  const cacheKey = generatePCACacheKey(selectedDataset, selectedMethod);
  return selectPCAForCacheKey(state, cacheKey);
};
